import { useId, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import Modal from '../Modal/Modal';
import Form from '../Form/Form';
import Button from '../Form/Button';
import InputPassword from '../Form/Fields/InputPassword';
import { useAuth } from '../../context/AuthProvider';
import { API_BASE_URL } from '../../api';
import './DeactivateAccountSection.scss';

const DeactivateAccountSection = ({ user }) => {
  const { logout } = useAuth();
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  // This section renders both on the full /account page and inside the sidebar's quick
  // AccountModal, which can be mounted at the same time — unique per-instance ids keep
  // their modal/form pair from colliding in the DOM.
  const uid = useId();
  const modalId = `deactivateAccountModal-${uid}`;
  const formId = `deactivateAccountForm-${uid}`;

  const submit = (data) => {
    setLoading(true);
    axios.patch(`${API_BASE_URL}/api/auth/me/deactivate`, data, { withCredentials: true })
      .then(() => {
        toast.success('Votre compte a été désactivé.');
        logout();
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || 'Une erreur est survenue.');
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="account-danger-zone">
      <div className="account-danger-zone__box">
        <div className="account-danger-zone__header">
          <span className="account-danger-zone__icon">
            <FontAwesomeIcon icon={faTriangleExclamation} />
          </span>
          <div>
            <div className="account-danger-zone__title">Désactiver mon compte</div>
            <p className="account-danger-zone__desc">
              Votre compte sera désactivé et vous serez immédiatement déconnecté. Un administrateur
              devra le réactiver pour que vous puissiez vous reconnecter.
            </p>
          </div>
        </div>

        {user.admin ? (
          <button type="button" className="account-danger-zone__btn" onClick={() => setShowConfirm(true)}>
            <FontAwesomeIcon icon={faPowerOff} />
            Désactiver mon compte
          </button>
        ) : (
          <p className="account-danger-zone__restricted">
            Seul un administrateur peut désactiver ce compte. Contactez un administrateur de votre
            pharmacie si nécessaire.
          </p>
        )}
      </div>

      <Modal
        id={modalId}
        title="Désactiver votre compte ?"
        show={showConfirm}
        onClose={() => setShowConfirm(false)}
        icon={faTriangleExclamation}
        iconBg="#fef2f2"
        iconColor="#dc2626"
        footer={
          <Button
            isLoading={loading}
            loadingMessage="Désactivation…"
            className="modal-btn-danger"
            type="submit"
            form={formId}
          >
            Désactiver mon compte
          </Button>
        }
      >
        <p style={{ fontSize: 13, color: '#6b7280', margin: '0 0 16px', lineHeight: 1.6 }}>
          Cette action est immédiate : vous serez déconnecté et ne pourrez plus vous reconnecter
          tant qu'un administrateur n'aura pas réactivé votre compte. Confirmez votre mot de passe
          actuel pour continuer.
        </p>
        <Form id={formId} onSubmit={submit}>
          <span className="cdm-field-label">Mot de passe actuel <span className="text-danger">*</span></span>
          <InputPassword
            name="currentPassword"
            placeholder="Mot de passe actuel"
            validationRules={{ required: 'Le mot de passe est obligatoire' }}
          />
        </Form>
      </Modal>
    </div>
  );
};

export default DeactivateAccountSection;
